import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PlatformOwnerGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    const session = await this.authService.getSession();
    if (session?.role === 'platformOwner') {
      return true;
    }
    await this.router.navigateByUrl('/owner/login', { replaceUrl: true });
    return false;
  }
}
